import { barnToolsApi } from './base';
import { ISensorCollection } from './types';

export const sensorApi = barnToolsApi
  .enhanceEndpoints({ addTagTypes: ['sensors'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllSensors: builder.query<ISensorCollection, void>({
        query: () => `sensors/`,
        providesTags: ['sensors'],
      }),
      getSensorsByGateway: builder.query<ISensorCollection, string>({
        query: (gatewayId) => {
          return {
            url: `/gateways/${gatewayId}/sensors/`,
          };
        },
        providesTags: ['sensors'],
      }),
      updateSensorOrder: builder.mutation<
        { success: boolean; id: string },
        string[]
      >({
        query: (sensorIds) => {
          return {
            url: `sensors/`,
            method: `PATCH`,
            body: sensorIds,
          };
        },
        invalidatesTags: ['sensors'],
      }),
    }),
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllSensorsQuery,
  useGetSensorsByGatewayQuery,
  useUpdateSensorOrderMutation,
} = sensorApi;
